import { defineMessages } from 'react-intl';

export default defineMessages({
  shipmentNotificationEmailsTitle: {
    description: 'graph title for the shipment notification emails chart',
    defaultMessage: 'Shipment Confirmation Emails',
    id: '04M6lu',
  },
  deliveryNotificationEmailsTitle: {
    description: 'graph title for the delivery notification emails chart',
    defaultMessage: 'Delivery Notification Emails',
    id: 'Zx1WPC',
  },
  turnOnShipmentNotificationEmailsMessage: {
    description: 'description of shipment confirmation emails and instructions on how to turn them on',
    defaultMessage:
      "You haven't enabled Shipment Confirmation Emails. To notify your customers when their order has shipped, select a Shipment Confirmation Email template in your store's <link>Email Settings</link>.",
    id: '8Xw53z',
  },
  turnOnDeliveryNotificationEmailsMessage: {
    description: 'description of delivery notification emails and instructions on how to turn them on',
    defaultMessage:
      "You haven't enabled Delivery Notification Emails. To notify your customers when their order has been delivered, select a Delivery Notification Email template in your store's <link>Email Settings</link>.",
    id: 'Lc8ysE',
  },
});
